import { Divider, Grid } from '@mui/material';
import React from 'react';
import { useGetIndividualConversationQuery } from '../../../app/Slices/SevenDayApiSlice';
import AIHistoryChatComponent from '../../components/Reservations/AIReservations/AIHistoryChatComponent';
import AIHistoryChatComponentLoading from '../../components/Reservations/AIReservations/AIHistoryChatComponentLoading';
import AIHistoryIndividualPageDetails from './AIHistoryIndividualPageDetails';
import AIHistoryIndividualPageDetailsLoading from './AIHistoryIndividualPageDetailsLoading';

const AiHistoryIndividualPage = () => {
    const urlRef = window.location.href.split('/')[4];

    const { data, isFetching, error } = useGetIndividualConversationQuery(
        `ai/conversations/${urlRef}`,
    );

    return (
        <Grid sx={{ position: 'relative' }}>
            <Grid
                sx={{
                    paddingBottom: '30px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    position: 'sticky',
                    zIndex: 1,
                    top: 0,
                    marginTop: '-80px',
                    paddingTop: '80px',
                    bgcolor: 'white',
                }}
            >
                {!isFetching && <AIHistoryIndividualPageDetails data={data} />}
                {isFetching && <AIHistoryIndividualPageDetailsLoading />}

                <Divider />
            </Grid>
            {!isFetching && <AIHistoryChatComponent data={data} />}
            {isFetching && <AIHistoryChatComponentLoading />}
        </Grid>
    );
};

export default AiHistoryIndividualPage;
